import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetStep } from '@store/slices/login.slice';
import { getAccessToken, isTokenExpired } from '@utils/helpers';

const TokenGuard = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = getAccessToken();
    if (!token || isTokenExpired(token)) {
      dispatch(resetStep());
    }
  }, [dispatch]);

  return <>{children}</>;
};

export default TokenGuard;
